// extracted by mini-css-extract-plugin
module.exports = {"base":"InPageSubNav_base__sEP4t","isSticky":"InPageSubNav_isSticky__GUZ7T","isMainHeaderVisible":"InPageSubNav_isMainHeaderVisible__EX2Dw"};